


$(document).on("click", ".fbt_main_heading", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).removeClass('active');
    jQuery('.custom_fbt_main').slideUp();
  } else {
    jQuery(this).addClass('active');
    jQuery('.custom_fbt_main').slideDown();
  }
});


$(document).on("click", ".custom_ajax__item_add", function (e) {
var fbt_main = $(this).parents('.product_loop_item_main');
$(this).hide();
 fbt_main.find('.custom_ajax__item_remove').css('display','flex');
 fbt_main.find('input').trigger('click');
});
$(document).on("click", ".custom_ajax__item_remove", function (e) {
var fbt_main = $(this).parents('.product_loop_item_main');
$(this).hide();
 fbt_main.find('.custom_ajax__item_add').css('display','flex');
 fbt_main.find('input').trigger('click');
});



$(document).on("change", '.custom_fbt_bottom_check_flex input', function(event) { 
var product_id = $(this).val();
var details_main = $('.custom_fbt_top_left_item[product_id="'+product_id+'"]');
  if($(this).prop('checked')) {
details_main.show().addClass('active');
  } else {
details_main.hide().removeClass('active');  
  }
var fbt_main = $(this).parents('.custom_fbt_main');
  update_fbt_price(fbt_main);
});


$(document).on("change", 'select.variant_change_lp', function(event) {
  var selected = $(this).find('option:selected'); 
var product_id = $(this).attr('product_id');
var variant_id = $(this).val();
var price = selected.attr('variant_price');
var compare_price = selected.attr('compare_price');
var details_main = $('.custom_fbt_top_left_item[product_id="'+product_id+'"]');
details_main.attr('price',price);
details_main.attr('compare_price',compare_price);
$('.product_bundle_price_single[product_id="'+product_id+'"] .item_prices_bundle').hide();
$('.product_bundle_price_single[product_id="'+product_id+'"] .item_prices_bundle[variant_id="'+variant_id+'"]').css('display','flex');
var fbt_main = $(this).parents('.custom_fbt_main');
  update_fbt_price(fbt_main);
});


function update_fbt_price(fbt_main) {
  var totalPrice = 0;
  var totalComparePrice = 0;
  var currency =  fbt_main.find('.custom_fbt_top_left_item').attr('currency'); 

  fbt_main.find('.custom_fbt_top_left_item.active').each(function() {
    var price = parseFloat($(this).attr('price')/100);
    var compare = parseFloat($(this).attr('compare_price')/100);
    totalPrice += price;
    totalComparePrice += compare;
  });
  var quantity = parseInt(fbt_main.find('input.fbt_quantity').val());
totalPrice = totalPrice * quantity;
totalComparePrice = totalComparePrice * quantity;
totalPrice = parseFloat(totalPrice).toFixed(2);
totalComparePrice = parseFloat(totalComparePrice).toFixed(2);
  // Format numbers with 2 decimals and add currency
  var formattedPrice = currency + totalPrice;
  var formattedCompare = currency + totalComparePrice;

  // Update DOM
  fbt_main.find('span.price_ajax').text(formattedPrice);
  fbt_main.find('span.compare_price_ajax').text(formattedCompare);
}



$(document).on("click", '.custom_ajax_add_all:not(.loading_hk)', function(e) {
  e.preventDefault();
  var $btn = $(this).addClass('loading_hk');

  var fbt_main = $(this).parents('.custom_fbt_main');
  var quantity = parseInt($(this).parents('.custom_fbt_main').find('input.fbt_quantity').val());
  var items = [];

  // Loop through ACTIVE top items
  fbt_main.find('.custom_fbt_top_left_item.active').each(function() {

    var variantId = $(this).attr('variant_id');
    var productId = $(this).attr('product_id');

    // Find all dropdowns for this product inside fbt_main
    var $allDropdowns = fbt_main.find('.variant_change_lp[product_id="' + productId + '"]');

    if ($allDropdowns.length > 0) {
      // ******************************************
      // CASE 1: Dropdowns exist → count quantities
      // ******************************************
      var variantCountMap = {};

      $allDropdowns.each(function() {
        var vID = $(this).val(); // dropdown value = variant_id
        variantCountMap[vID] = (variantCountMap[vID] || 0) + 1;
      });

      // PUSH each variant with its real quantity
      for (var vid in variantCountMap) {
        items.push({
          id: vid,
          quantity: variantCountMap[vid]
        });
      }

    } else {
      // ******************************************
      // CASE 2: No dropdowns → fallback to old logic
      // ******************************************
      items.push({
        id: variantId,
        quantity: quantity
      });
    }
  });

  // If nothing selected
  if (items.length === 0) {
    console.warn('No active variants found.');
    $btn.removeClass('loading_hk');
    return;
  }

  // ===========================================
  // AJAX: ADD ALL TO CART
  // ===========================================
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: JSON.stringify({ items: items }),
    contentType: 'application/json',
    success: function() {
      $('cart-drawer').trigger('_onCartRefreshListener');
      document.querySelector('cart-drawer')?.setAttribute('open', '');
      $btn.removeClass('loading_hk');
    },
    error: function(xhr) {
      console.error('Add to cart failed:', xhr.responseText);
      $btn.removeClass('loading_hk');
    }
  });

});


function updateFBTQuantity($input) {
  var newVal = parseInt($input.val()) || 1;
  console.log("Quantity updated to:", newVal);

  var $fbt_main = $input.closest('.custom_fbt_main');

  // Loop through each product block inside this fbt_main
  $fbt_main.find('.custom_fbt_bottom_check').each(function () {

    var $productBlock = $(this); // each block
    var $container = $productBlock.find('.variant_container_lp'); 
    var $variant = $productBlock.find('.variant_change_lp').first(); // original dropdown

    if ($variant.length === 0) return; // safety

    // Clear previous clones
    $container.empty();

    // Add N clones
    for (var i = 0; i < newVal; i++) {
      var $clone = $variant.clone();

      // Optional: modify name/id to avoid duplicates
      $clone.attr("data-index", i);

      $container.append($clone);
    }

  });

  update_fbt_price($fbt_main);
}






  $(document).on('click', '.quantity_plus_fbt', function() {
    var $wrapper = $(this).closest('.custom_quantity_fbt');
    var $input = $wrapper.find('.fbt_quantity');
    var $minus = $wrapper.find('.quantity_minus_fbt');
    var $plus = $wrapper.find('.quantity_plus_fbt');
    
    var current = parseInt($input.val()) || 1;
    if (current < 2) {
    $input.val(current + 1);
    $minus.removeAttr('disabled').removeClass('disabled');
    }
    if (parseInt($input.val()) >= 2) {
     $plus.attr('disabled', true).addClass('disabled');
    }
    
    updateFBTQuantity($input); // 🔥 run function on change
  });

  $(document).on('click', '.quantity_minus_fbt', function() {
    var $wrapper = $(this).closest('.custom_quantity_fbt');
    var $input = $wrapper.find('.fbt_quantity');
    var $minus = $(this);
    var $plus = $wrapper.find('.quantity_plus_fbt');
    
    var current = parseInt($input.val()) || 1;
    if (current > 1) {
      $input.val(current - 1);
    $plus.removeAttr('disabled').removeClass('disabled');
    }
    if (parseInt($input.val()) <= 1) {
      $minus.attr('disabled', true).addClass('disabled');
    }

    updateFBTQuantity($input); // 🔥 run function on change
  });




    $(document).on('click', '.quantity_plus_cart:not(.loading_hk)', function() {
    $(this).addClass('loading_hk');
    var $wrapper = $(this).closest('.custom_quantity_flex_cart');
    var $input = $wrapper.find('.cart_quantity');
    var $minus = $wrapper.find('.quantity_minus_cart');
    var $plus = $wrapper.find('.quantity_plus_cart');
    
    var current = parseInt($input.val()) || 1;
    $input.val(current + 1).trigger('change');
    $minus.removeAttr('disabled').removeClass('disabled');
 var key = $input.attr('key');
var newQty = $input.val();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: key,
      quantity: newQty
    },
    dataType: 'json',
    success: function(cart) {
   $('cart-drawer').trigger('_onCartRefreshListener'); 
    },
    error: function(err) {
   $('cart-drawer').trigger('_onCartRefreshListener'); 
    }
  });
  });

  $(document).on('click', '.quantity_minus_cart:not(.loading_hk)', function() {
    $(this).addClass('loading_hk');
    var $wrapper = $(this).closest('.custom_quantity_flex_cart');
    var $input = $wrapper.find('.cart_quantity');
    var $minus = $(this);
    var $plus = $wrapper.find('.quantity_plus_cart');
    
    var current = parseInt($input.val()) || 1;
    if (current > 1) {
      $input.val(current - 1).trigger('change');
    $plus.removeAttr('disabled').removeClass('disabled');
    }
    if (parseInt($input.val()) <= 1) {
      $minus.attr('disabled', true).addClass('disabled');
    }
 var key = $input.attr('key');
var newQty = $input.val();
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: key,
      quantity: newQty
    },
    dataType: 'json',
    success: function(cart) {
   $('cart-drawer').trigger('_onCartRefreshListener'); 
    },
    error: function(err) {
   $('cart-drawer').trigger('_onCartRefreshListener'); 
    }
  });

 
  });



  

$(document).on("click", ".variant_image", function (e) {
var product_id = $(this).attr('product_id');
$('.custom_product_popup[product_id="'+product_id+'"]').show().addClass('active');
$('.custom_product_popup.active').find('.slick-slider').each(function () {
    $(this).slick('refresh');
  });
});


$(document).on("click", ".product_popup_close, .product_popup_bg", function (e) {
$('.custom_product_popup').hide().removeClass('active');
});
